import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PRODUCTS_FEATURE_GROUP } from './group';

export const PRODUCTS_FEATURES = {
  READ: {
    guid: 'e1b4ca45-7d3f-4e90-a123-8f0e1d2b0000',
    name: 'products:read',
    description: 'View the products dashboard',
    action: 'read',
    product: 'account',
    parentGuid: PRODUCTS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PRODUCTS_FEATURE_GROUP } from './group';

export const PRODUCTS_MODULE: FeatureModule = {
  product: 'account',
  groups: [PRODUCTS_FEATURE_GROUP],
  features: featureList(PRODUCTS_FEATURES),
};
